import TextUnderlineStyles from './types';

const textUnderline: TextUnderlineStyles = {
    textUnderlinePositionUnder: {
        textUnderlinePosition: 'under',
    },
    textDecorationSkipInkNone: {
        textDecorationSkipInk: 'none',
    },
};

export default textUnderline;
